import { BaseIcon, BaseIconProps } from './BaseIcon';

export const FilmGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="filmGrad" {...props}>
    <rect width="18" height="18" x="3" y="3" rx="2" stroke="url(#filmGrad)" />
    <path d="M7 3v18M3 7.5h4M3 12h18M3 16.5h4M17 3v18M17 16.5h4M17 12h4M17 7.5h4" stroke="url(#filmGrad)" />
  </BaseIcon>
);
